import { render, staticRenderFns } from "./ParametrizacaoAcaoPasso5.vue?vue&type=template&id=11b85f88&lang=html"
import script from "./ParametrizacaoAcaoPasso5.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoAcaoPasso5.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoAcaoPasso5.vue?vue&type=style&index=0&id=11b85f88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports